import styled from 'styled-components';
import colors from '../../../../node_modules/pubweb-react-components/dist/styles/colors';
import LandingPageStyles from '../../../styles/LandingPageStyles';
import PropTypes from 'prop-types';

const FormGroup = styled.div`

  @media screen and (${LandingPageStyles.viewBreakpoints.desktop}){
    padding-left: 35px;
    padding-right: 34px;
    margin-bottom: 15px;

    label {
      letter-spacing: -.7px;
    }

    .checkboxContainer{
      cursor: pointer;
      display: block;
      font-size: 16px;
      letter-spacing: -0.6px;
      line-height: 1.44;
      padding-left: 30px;
      position: relative;
      user-select: none;

      input{
        position: absolute;
        opacity: 0;
        cursor: pointer;
      }

      input:checked ~ .checkbox{
        background-color: ${colors.primaryClaytonBlue};
        border: 2px solid ${colors.primaryClaytonBlue};
      }
      
      .checkbox{
        position: absolute;
        top: 7px;
        left: 0px;
        height: 20px;
        width: 20px;
        border: 2px solid ${colors.grayscaleCoolGray06};
      }
      .checkbox:after{
        content: "";
        position: absolute;
        display: none;
      }
      input:checked ~ .checkbox:after{
        display: block;
      }
      .checkbox:after{
        left: 4px;
        top: 0;
        width: 5px;
        height: 10px;
        border: 2px solid #ffffff;
        border-width: 0 3px 3px 0;
        transform: rotate(45deg);
      }
    }
  }


  
  @media screen and (${LandingPageStyles.viewBreakpoints.tablet}){
    padding-left: 18px;
    padding-right: 23px;
    margin-bottom: 15px;

    label {
      letter-spacing: -.7px;
    }

    .checkboxContainer{
      cursor: pointer;
      display: block;
      font-size: 16px;
      letter-spacing: -0.6px;
      line-height: 1.44;
      margin-bottom: 22px;
      padding-left: 30px;
      position: relative;
      user-select: none;

      input{
        position: absolute;
        opacity: 0;
        cursor: pointer;
      }

      input:checked ~ .checkbox{
        background-color: ${colors.primaryClaytonBlue};
        border: 2px solid ${colors.primaryClaytonBlue};
      }
      
      .checkbox{
        position: absolute;
        top: 7px;
        left: 0px;
        height: 20px;
        width: 20px;
        border: 2px solid ${colors.grayscaleCoolGray06};
      }
      .checkbox:after{
        content: "";
        position: absolute;
        display: none;
      }
      input:checked ~ .checkbox:after{
        display: block;
      }
      .checkbox:after{
        left: 4px;
        top: 0;
        width: 5px;
        height: 10px;
        border: 2px solid #ffffff;
        border-width: 0 3px 3px 0;
        transform: rotate(45deg);
      }
    }
  }

  @media screen and (${LandingPageStyles.viewBreakpoints.mobile}){
    padding-left: 19px;
    padding-right: 23px;
    margin-bottom: 3px;

    label {
      letter-spacing: -.7px;
    }

    .checkboxContainer{
      cursor: pointer;
      display: block;
      font-size: 16px;
      letter-spacing: -1px;
      line-height: 1.44;
      margin-bottom: 22px;
      padding-left: 30px;
      position: relative;
      user-select: none;

      input{
        position: absolute;
        opacity: 0;
        cursor: pointer;
      }

      input:checked ~ .checkbox{
        background-color: ${colors.primaryClaytonBlue};
        border: 2px solid ${colors.primaryClaytonBlue};
      }
      
      .checkbox{
        position: absolute;
        top: 7px;
        left: 0px;
        height: 20px;
        width: 20px;
        border: 2px solid ${colors.grayscaleCoolGray06};
      }
      .checkbox:after{
        content: "";
        position: absolute;
        display: none;
      }
      input:checked ~ .checkbox:after{
        display: block;
      }
      .checkbox:after{
        left: 4px;
        top: 0;
        width: 5px;
        height: 10px;
        border: 2px solid #ffffff;
        border-width: 0 3px 3px 0;
        transform: rotate(45deg);
      }
    }
  }
`;

FormGroup.propTypes = {
  inline: PropTypes.bool,
  width: PropTypes.string
};

export default FormGroup;



// WEBPACK FOOTER //
// ./src/components/Form/styles/FormGroup.js